import { render, staticRenderFns } from "./DigitalCulture.vue?vue&type=template&id=5f453ab0&scoped=true&"
import script from "./DigitalCulture.vue?vue&type=script&lang=js&"
export * from "./DigitalCulture.vue?vue&type=script&lang=js&"
import style0 from "./DigitalCulture.vue?vue&type=style&index=0&id=5f453ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f453ab0",
  null
  
)

export default component.exports